import React from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import Spinner from '~/components/spinner/spinner';
import VesselTypeSummaryCard from '~/components/vesselTypeSummaryCard/vesselTypeSummaryCard';
import VesselTypeProductVariantListCard from '~/components/vesselTypeProductVariantListCard/vesselTypeProductVariantListCard';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getVesselTypeQuery = gql`
  query vesselType($id: Int!) {
    vesselType(id: $id) {
      id
      name
      description
      volume
      quantity
      variants {
        id
        name
        product {
          id
          name
        }
      }
    }
  }
`;

const Ingredient = ({ onCompleted, id }) => (
  <Query query={getVesselTypeQuery} variables={{ id }} onCompleted={onCompleted} fetchPolicy={'cache-and-network'}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <Spinner className="absolute absolute-center stroke-brand-red" />;
      }

      if (error) {
        return <ErrorBoundaryContent error={error} />;
      }

      const { vesselType } = data;
      return (
        <div className="flex content">
          <div className="flex-2 mr4">
            <VesselTypeProductVariantListCard {...vesselType} />
          </div>
          <div className="flex-1">
            <VesselTypeSummaryCard className="mb4" {...vesselType} />
          </div>
        </div>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(Ingredient);



// WEBPACK FOOTER //
// ./src/containers/vesselType/vesselType.jsx